import { useEffect, useRef } from 'react';
import { navigate } from 'vike/client/router';

import { openMoreSheet } from '@/renderer/utils/moreSheet';
import useMe, { authToken } from '@/renderer/utils/useMe';

export default MorePage;

/**
 * /more is a deep link, not a page (#2142). The More menu is a bottom sheet over
 * whatever page the tab bar is on (components/Nav/MoreSheet.tsx), so this
 * replaces its own history entry with the release center (the public archive
 * for signed-out visitors, whose Results tab it is) and opens the sheet over it.
 * Kept so links from support and older app builds still land on the menu.
 */
function MorePage() {
  const user = useMe();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) {
      return;
    }
    started.current = true;

    // The session may still be resolving on a cold deep link (`user` is
    // undefined until it does); a stored token is the signed-in signal then.
    const signedIn = user === undefined ? !!authToken() : !!user?.role;

    void navigate(signedIn ? '/release-center' : '/archive', {
      overwriteLastHistoryEntry: true,
    }).then(() => {
      openMoreSheet();
    });
  }, [user]);

  return <div className="flex-1" />;
}
